import React, { useCallback, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { formatBytes } from 'utils/utils'
import { useDropzone } from 'react-dropzone'
import {
  Paper,
  Typography,
  Grid,
  FormControl,
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText
} from '@material-ui/core'

import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import DeleteIcon from '@material-ui/icons/Delete'

import useStyles from './dropZone.styles'

const DropZone = ({
  pesoTotalDeArchivos,
  archivos,
  setArchivos,
  loading,
  customOnChange,
  validarPesoMaximoDeArchivos,
  validarArchivosConError,
  esCargaMasiva
}) => {
  const classes = useStyles()

  const onDrop = useCallback(acceptedFiles => {
    if (!acceptedFiles.length) return

    validarArchivosConError(acceptedFiles)
  })

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop
  })

  useEffect(() => {
    if (archivos.length > 0) {
      customOnChange(
        'pesoTotalDeArchivos',
        archivos.map(file => file.size).reduce((pre, curr) => pre + curr)
      )
    }
    return () => {}
  }, [archivos])

  useEffect(() => {
    validarPesoMaximoDeArchivos()
    return () => {}
  }, [pesoTotalDeArchivos])

  const classNameDropZone = clsx({
    [classes.dropZone]: true,
    [classes.isDragActive]: isDragActive
  })

  const eliminarSoporte = archivo => {
    const nuevaListaSoportes = [...archivos]
    nuevaListaSoportes.splice(nuevaListaSoportes.indexOf(archivo), 1)
    setArchivos(nuevaListaSoportes)
  }

  const mostrarArchivosAceptados = archivos.map(file => {
    const mensaje = file.mensajeError ? `*** ${file.mensajeError} ***` : ''
    return (
      <ListItem key={file.path}>
        <ListItemIcon disabled={loading}>
          <IconButton
            color='secondary'
            aria-label='Eliminar soporte'
            onClick={() => eliminarSoporte(file)}
            disabled={loading}
          >
            <DeleteIcon />
          </IconButton>
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{ variant: 'h5' }}
          primary={`${file.path} - ${formatBytes(file.size, 2)}`}
        />
        <ListItemText
          primaryTypographyProps={{ variant: 'h6' }}
          primary={mensaje}
          style={{ marginLeft: 10, color: 'red' }}
        />
      </ListItem>
    )
  })
  return (
    <Grid item>
      <Paper {...getRootProps()} elevation={3} className={classNameDropZone}>
        <input {...getInputProps()} />
        <Typography variant='h5' align='center' style={{ margin: 20 }}>
          Arrastra o haz clic aquí para seleccionar los archivos{' '}
          {esCargaMasiva ? '.zip' : 'tif o pdf'}
        </Typography>
        {esCargaMasiva && (
          <Typography variant='h6' align='center' style={{ margin: 20 }}>
            Estructura del archivo: NIT_ALFA_NUMFACTURA_VALOR_PBS/NPBS
          </Typography>
        )}
        <Grid container justify='center'>
          <CloudUploadIcon color='disabled' style={{ fontSize: 100 }} />
        </Grid>
      </Paper>
      <FormControl className={classes.formControl} fullWidth>
        {archivos.length > 0 && (
          <>
            <Typography variant='h6' align='center' style={{ marginTop: 20 }}>
              {archivos.length} archivos adjuntos con un peso total de{' '}
              <strong>{formatBytes(pesoTotalDeArchivos)}</strong>
            </Typography>
            <Paper elevation={4} style={{ marginTop: 20 }}>
              <Grid container justify='center' style={{ minHeight: 50 }}>
                <Grid item sm={12}></Grid>
                <Grid item sm={12}>
                  <List component='nav' aria-label='main mailbox folders'>
                    {mostrarArchivosAceptados}
                  </List>
                </Grid>
              </Grid>
            </Paper>
          </>
        )}
      </FormControl>
    </Grid>
  )
}

DropZone.propTypes = {
  archivos: PropTypes.arrayOf(PropTypes.object).isRequired,
  setArchivos: PropTypes.func.isRequired
}

export default React.memo(DropZone)
